import React, { useContext, useEffect, useRef, useState } from 'react'
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
// import { ShowResult } from '../searchMenu/ActionOnSearch';
import { GVarState } from '../StoreState/Gstate';
import './SearchWeb.css'
import StepByStep from './StepByStep';
import { SvgDirections } from './SvgSearch';
import { ShowResult } from '../Action/Action';
function SearchWeb() {
  let g = useContext(GVarState);
  let setwrap = useRef()
  const [elevator, setelevator] = useState(false);
  const [escalator, setescalator] = useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()
  function FilterValue(e, g, prarambh) {
    if (prarambh === "end") {
      g.setEndSearchInput({ name: e.target.value })
      let x = ShowResult(e, g)
      g.setDisplayEndPointResult(x)
      g.setDisplayStartPointResult(null)

    } else if (prarambh == "start") {
      g.setStartSearchInput({ name: e.target.value })
      let x = ShowResult(e, g)
      g.setDisplayEndPointResult(null)
      g.setDisplayStartPointResult(x)
    } else {
      g.setEndSearchInput({ name: e.target.value })
      let x = ShowResult(e, g)
      g.setDisplayStartPointResult(null)
      g.setDisplayEndPointResult(x)
    }
  }
  useEffect(() => {
    if (elevator && escalator) {
      g.setPointType({ ...g.PointType, elevator: false, escalator: false, stair: true, });
    } else if (elevator) {
      g.setPointType({ ...g.PointType, elevator: false, escalator: true, stair: true, });
    } else if (escalator) {
      g.setPointType({ ...g.PointType, elevator: true, escalator: false, stair: true, });
    } else {
      g.setPointType({ ...g.PointType, elevator: false, escalator: false, stair: false, });
    }
  }, [elevator, escalator]);

  useEffect(() => {
    if (g.EndSearchInput?.point && g.StartSearchInput?.point) {
      if (g.EndSearchInput?.point.LocationName.text !== g.StartSearchInput?.point.LocationName.text) {
        let { x, y, z } = g.StartSearchInput?.point
        if (g.mallType) {
          const params = { v: searchParams.get("v"), m: g.mallType, from: `${g.EndSearchInput?.point.x},${g.EndSearchInput?.point.y},${g.EndSearchInput?.point.z}`, to: `${x},${y},${z}`, elevator: elevator, escalator: escalator };

          navigate({
            pathname: '/',
            search: `?${createSearchParams(params,)}`,
          });
        }
      } else {
        alert("start and end destination is same")
      }
    }

  }, [g.StartSearchInput?.point, g.EndSearchInput?.point, elevator, escalator])




  if (g.StartAndEndPart) {
    return (
      <>
        {/* g.DisplayStartPointResult */}
        {g.DisplayStartPointResult && <div className='DisplayStartPointResultLand' style={{ top: g.path.length > 1 ? "280px" : "230px" }}>
          {g.DisplayStartPointResult.map((d, i) => {
            return <div key={i} className='flex border-b-2 items-center cursor-pointer'
              onClick={() => {
                g.setStartSearchInput({ name: d.LocationName.text, point: d });
                g.setDisplayStartPointResult(null);
              }} >
              <span className="w-16">
                <img src={d.logo.url} className="w-full p-3" />
              </span>
              <span className='w-full p-1'>
                <p> {d.LocationName.text} </p>
              </span>
            </div>

          })}
        </div>
        }
        {/* g.DisplayEndPointResult */}
        {g.DisplayEndPointResult && <div className='DisplayEndPointResultLand' style={{ top: g.path.length > 1 ? "280px" : "230px" }}>
          {g.DisplayEndPointResult.map((d, i) => {
            return <div key={i} className='flex border-b-2 items-center cursor-pointer'
              onClick={() => {
                g.setEndSearchInput({ name: d.LocationName.text, point: d });
                g.setDisplayEndPointResult(null)

                // 
                let params = {};
                searchParams.forEach((d, i) => {
                  if (i == "v" || i == "m") params[i] = d;
                });
                let selectData = btoa(`${d.x},${d.y},${d.z} `);
                params.selectData = selectData;
                // navigate({
                //   pathname: "/",
                //   search: `?${createSearchParams(params)}`,
                // });
              }} >
              <span className="w-16">
                <img src={d.logo.url} className="w-full p-3" />
              </span>
              <span className='w-full p-1'>
                <p> {d.LocationName.text} </p>
              </span>
            </div>
          })}
        </div>
        }
        {/* searchBar box  */}
        <div className='SearchStartEndData'>
          {/* top Direction title  */}
          <div className='flex items-center'>
            <img className='p-2 w-7' src='./icon/backbtn.png' onClick={() => {
              g.setStartAndEndPart(false)
              if (g.path.length) {

                let params = {};
                searchParams.forEach((d, i) => {
                  if (i == "v" || i == "m") params[i] = d;
                });
                let selectData = btoa(`${g.selectShapData.x},${g.selectShapData.y},${g.selectShapData.z} `);
                params.selectData = selectData;
                g.setselectPointA(null)
                g.setpath([])
                navigate({
                  pathname: "/",
                  search: `?${createSearchParams(params)}`,
                });
              }


            }} />
            <p className='p-2 text-xl font-bold'>Direction</p>
          </div>
          {/* meddil search bar and icon */}
          <div className='flex items-center'>
            <span className='flex flex-col items-center w-12 '>
              <img className='w-3' src='./icon/Ellipse.png' />
              <img style={{ width: "1px", height: "35px" }} src='./icon/Line.png' />
              <img className='w-3' src='./icon/Vector.png' />
            </span>
            <span className='flex flex-col items-center '>
              <input type="text" className='p-2 rounded-t-md'
                value={g.StartSearchInput ? g.StartSearchInput.name : ""}
                onChange={(e) => FilterValue(e, g, "start")} onFocus={(e) => {
                  if (document.querySelector(".stapebystape")) {
                    document.querySelector(".stapebystape").style.height = "45px"
                    document.querySelector(".stapechilder").style.display = "none"
                  }
                  FilterValue(e, g, "start")
                }}
              />
              <input type="text" className='p-2 border-t-2 rounded-b-md'
                value={g.EndSearchInput ? g.EndSearchInput.name : ""}
                onChange={(e) => FilterValue(e, g, "end")}
                onFocus={(e) => {
                  if (document.querySelector(".stapebystape")) {
                    document.querySelector(".stapebystape").style.height = "45px"
                    document.querySelector(".stapechilder").style.display = "none"
                  }
                  FilterValue(e, g, "end")
                }}
              />
            </span>
            <span className='cursor-pointer' onClick={() => {
              let startpoint = { ...g.StartSearchInput }
              let endpoint = { ...g.EndSearchInput }
              g.setStartSearchInput({ ...endpoint })
              g.setEndSearchInput({ ...startpoint })
            }}>
              <img className='w-12 p-2' src='./icon/Direction.png' />
            </span>
          </div>
          {/* elevator and escalator checkbox */}
          <div className="flex justify-around py-2">
            <span>
              <label className="container">
                <b>Elevator</b>
                <input type="checkbox" checked={elevator} onChange={() => setelevator(!elevator)} />
                <span className="checkmark"></span>
              </label>
            </span>
            <span>
              <label className="container">
                <b>Escalator</b>
                <input type="checkbox" checked={escalator} onChange={() => setescalator(!escalator)} />
                <span className="checkmark"></span>
              </label>
            </span>
          </div>
          {g.path.length > 1 && <StepByStep />}
          {/* <StepByStep /> */}

        </div>


      </>
    )
  } else {
    return (
      <>
        <div className='SearchMenuStartLand'>
          <div className='searchInputLand'>
            <span onClick={() => {
              const params = { v: searchParams.get("v"), m: g.mallType };
              g.setDisplayEndPointResult(null)
              g.setEndSearchInput(null)
              g.setselectPointB(null)
              g.setSelectShapData(null)
              g.setpinArray([])
              navigate({
                pathname: '/',
                search: `?${createSearchParams(params,)}`,
              });
            }}><img src='./icon/backbtn.png' /></span>
            <span>
              <input type="text" placeholder='Search Your Loved Brand'
                value={g.EndSearchInput ? g.EndSearchInput.name : ""}
                onChange={(e) => FilterValue(e, g, "end")}
                onFocus={(e) => FilterValue(e, g, "end")}
              // onBlur={()=>{
              //   g.setDisplayEndPointResult(null)
              // }}
              />
            </span>
          </div>
          {g.EndSearchInput?.point && <div className='EndSearchPointLand'>

            {/*  slider*/}
            {g.EndSearchInput?.point && g.EndSearchInput.point.extra?.TotleImg &&
              <Slide cssClass="slider_class">
                {g.EndSearchInput.point.extra?.TotleImg.map((d, i) => {

                  return <div key={i}>
                    <img src={d[i]} />
                  </div>
                })}
              </Slide>
            }


            {/*  */}

            {/* <span>{slideImage.caption}</span> */}




            {/* logo and name  */}
            <div className='flex items-center'>
              <span className='w-24 bg-white rounded-lg'>
                <img src={g.EndSearchInput.point.logo.url} className="p-2 shadow-md rounded-lg m-auto" />
              </span>
              <span className='w-full p-2'>
                <p className='font-bold'>{g.EndSearchInput.point.LocationName.text}</p>
                <p className='text-xs'>{g.FloorImg[g.EndSearchInput.point.z].FloorName}</p>
              </span>
            </div>
            {/* Description*/}
            <div className='flex descripition_content flex-col gFayxe' ref={setwrap} onClick={() => {
              setwrap.current.classList.toggle("gFayxe");
              setwrap.current.classList.toggle("dAFXpl");
            }}  >
              <span>
                <p className='font-serif leading-5'>{g.EndSearchInput.point?.Description}</p>
              </span>
              {g.EndSearchInput.point.Category && g.EndSearchInput.point?.Category.trim().length > 0 &&
                <span className='py-2' >
                  <p className='shadow-md rounded-lg p-1 inline bg-white'>{g.EndSearchInput.point?.Category}</p>
                </span>
              }
            </div>
            {/* phonenumber */}
            {g.EndSearchInput?.point && g.EndSearchInput.point.extra?.mobile &&
              <div className='flex justify-between mobile_content'>
                <span className='flex items-center w-16 text-center rounded-md ' style={{ backgroundColor: "#62B43C" }}>
                  <img src='./icon/call.png' className='w-6' />
                  <p className='w-full text-white font-semibold'>Call</p>
                </span>
                <span className='w-ful'>
                  <p className='font-bold text-gray-900'>{g.EndSearchInput.point.extra?.mobile}</p>
                </span>
              </div>
            }

          </div>
          }
          {/* Directions */}
          {g.EndSearchInput?.point &&
            <div className='flex py-2 DirectionsLand' onClick={() => g.setStartAndEndPart(true)} >
              <span className='p-2'><SvgDirections /></span>
              <p className='p-2 font-bold text-lg'>Directions</p>
            </div>
          }
        </div>

        {g.DisplayEndPointResult && <div className='displayStartLand'>
          {g.DisplayEndPointResult.map((d, i) => {
            return d?.LocationName?.text?.trim().length>1 && <div key={i} className='flex border-b-2 items-center cursor-pointer'
              onClick={() => {
                g.setEndSearchInput({ name: d.LocationName.text, point: d });
                g.setDisplayEndPointResult(null)
                //  g.setselectPointB({name: `grid[${d.x}][${d.y}][${d.z}]`,point:d,x:d.x,y:d.y,z:d.z})
                let params = {};
                searchParams.forEach((d, i) => {
                  if (i == "v" || i == "m") params[i] = d;
                });
                let selectData = btoa(`${d.x},${d.y},${d.z} `);
                params.selectData = selectData;
                navigate({
                  pathname: "/",
                  search: `?${createSearchParams(params)}`,
                });
              }} >
              <span className="w-16">
                <img src={d.logo.url} className="w-full p-3" />
              </span>
              <span className='w-full p-1'>
                <p> {d.LocationName.text} </p>
              </span>
            </div>
          })}
        </div>
        }
      </>
    )
  }
}

export default SearchWeb